import React, {useState} from "react";
import css from "./selectDrop.module.css";
import {ClickAwayListener} from "@mui/base/ClickAwayListener";

export default function SelectDrop({data, placeholder, children}){
    const [isSelOpen, setIsSelOpen] = useState(false);
    const [sel, setSel] = useState(undefined);
    const [list, setList] = useState(data);
    // const [fltr, setFltr] = useState();

    const toggleSelect = ()=>{
        setIsSelOpen(!isSelOpen);
    }

    const selectItem = item=>{
        console.log(data[item]);
        setSel(item);
        setIsSelOpen(false);
    }

    const filterList = evt=>{
        // setFltr(evt.target.value);
        const fltr = evt.target.value;
        // setList(data.filter(item=>(new RegExp(fltr)).test(item)));
        // setList(data.filter(item=>new RegExp(String(fltr||'').toLowerCase()).test(String(item||'').toLowerCase())));
        setList(data.filter(item=>String(item||'').toLowerCase().includes((fltr||'').toLowerCase())));
    
    }

    return( 
        <ClickAwayListener onClickAway={()=>setIsSelOpen(false)}>
            <div className="selectDrop cursor position-relative">
                <span className={css.openSelect} onClick={toggleSelect}>{sel===undefined?placeholder:data[sel][1]===undefined?data[sel][0]:data[sel][1]}
                {children}
                </span>
                {isSelOpen===true&&<>
                    <div className={css.selectDrop}>
                        <div className={css.searchField}>
                            <input type="text" placeholder="search ..." onChange={filterList}/>
                        </div>
                        <ul className={css.searchResult}>
                            {/* <li className={css.active}>all categories</li> */}
                            {
                                list.map((item,idx)=><li key={idx} onClick={evt=>selectItem(idx)} className={sel===idx?css.active:""}>{item[1]===undefined?item[0]:item[1]}</li>)
                            }
                        </ul>
                    </div> 
                </>}
                
        
            </div>
        </ClickAwayListener>


    );
}